import jump from 'jump.js';
import Cookies from 'js-cookie'

$('[data-component="filter"]').on('change', (e) => {

  !$(e.currentTarget).val() ? $(e.currentTarget).toggleClass('no-value') : '';

  let name = $(e.currentTarget).attr('name');
  let val = $(e.currentTarget).val();
  let h = window.location.href;

  // making a filter get request

  if(window.location.search.search(name) >= 0) {

    h = window.removeParamURL(name, window.location.href);

  }

  if(val) {

    let l = '';

    if(window.location.search && window.location.search.substr(0, 1) == '?') {

      l = h + '&' + name + '=' + val;

    } else {

      l = h + '?' + name + '=' + val;

    }

    window.location = l.replace('?&', '?').replace('??', '?').replace('&&', '&');

  } else {

    if(h.split('/?')[1] == '') {

      window.location = h.substring(0, h.length - 1);

    } else {

      window.location = h;

    }

  }

});

$(document).ready(() => {

  $('#meganav a').click((e) => {
    Cookies.set('landed-from-nav');
  })

  if($('#field-type').val() || $('#field-brand').val() || $('#field-purpose').val() || $('#field-class').val()) {

    if (Cookies.get('landed-from-nav')) {

      Cookies.remove('landed-from-nav')

    } else {

      jump('.s--filters', {
        duration: 500,
        offset: -($('.g--header').height() * 1.25)
      });

    }

  }

  $('.form.form--filter select').each((i, v) => {

    !$(v).val() ? $(v).addClass('no-value') : '';

  })

})